<template>
    <div class="app-container">
      <div class="top-btn">
          <vxe-button status="success" @click="returnToLevel">返回</vxe-button>
      </div>
        <a-form label-algin="left" :label-col="{ style: { width: '160px' } }">
            <el-row :gutter="16">
              <el-col :span="6">
                  <a-form-item label="经销商名称:">
                      <a-input v-model="form.org_id_text" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                  <a-form-item label="申请人:">
                      <a-input v-model="form.sq_name" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                  <a-form-item label="申请类型:">
                    <a-input v-model="form.sq_type_text" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                
                <el-col :span="6">
                  <a-form-item label="申请时间:">
                      <a-input v-model="form.cdate" disabled placeholder=""></a-input>
                  </a-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                  <a-form-item label="送货地址:" :label-col="{ style: { width: '125px' } }">
                      <a-input v-model="form.sh_address" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                  <a-form-item label="收货人联系电话:">
                      <a-input v-model="form.sh_phone" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                  <a-form-item label="邮编:">
                    <a-input v-model="form.sh_zip" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col :span="12">
                    <a-form-item label="使用用途:" :label-col="{ style: { width: '125px' } }">
                        <a-textarea v-model="form.usage" disabled placeholder="" style="width:100%"></a-textarea>
                    </a-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 暂时没有字段 -->
                  <a-form-item label="发货单号:" :label-col="{ style: { width: '125px' } }">
                    <a-input v-model="form.rel_inv_code" disabled placeholder=""></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6" style="margin-left:-9px">
                  <a-form-item label="物料种类是否符合:" :label-col="{ style: { width: '190px' } }">
                      <a-input v-model="form.type_accord" disabled></a-input>
                  </a-form-item>
                </el-col>
                <el-col :span="6">
                  <a-form-item label="物料数量是否符合:" :label-col="{ style: { width: '190px' } }">
                      <a-input v-model="form.amount_accord" disabled></a-input>
                  </a-form-item>
                </el-col>
              <el-col :span="6">
                <a-form-item label="签收时间:" :label-col="{ style: { width: '180px' } }">
                  <a-input v-model="form.signed_time" disabled placeholder=""></a-input>
                </a-form-item>
              </el-col>
              <el-col :span="6">
                  <a-form-item label="签收人签名:">
                      <a-input v-model="form.mt_signed" disabled placeholder=""></a-input>
                      </a-form-item>
              </el-col>
            </el-row>
        </a-form>
        <h5>物料信息列表[(申请)支付金额合计:{{sqcostNum}}元; (审批)支付金额合计:{{spcostNum}}元]</h5>
        <div style="margin-top:30px">
            <vxe-table  
            :loading="listLoading"
            border
            resizable
            height="300"
            :align="allAlign"
            :data="tableData">
                <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
                <vxe-table-column field="mt_name" title="物料名称"></vxe-table-column>
                <vxe-table-column field="inventory" width="100" title="库存量"></vxe-table-column>
                <vxe-table-column field="cost" width="100" title="物料单价"></vxe-table-column>
                <vxe-table-column field="sq_amount" width="100" title="申请数量"></vxe-table-column>
                <vxe-table-column field="sqcost" title="（申请）支付金额"></vxe-table-column>
                <vxe-table-column field="sp_amount" width="100" title="审批数量"></vxe-table-column>
                <vxe-table-column field="spcost"  title="(审批)支付金额"></vxe-table-column>
                <vxe-table-column field="ss_amount" width="100" title="实收数量"></vxe-table-column>
            </vxe-table>
        </div>
        <div style="margin-top:30px">
          <vxe-table  
          :loading="listLoading"
          border
          resizable
          height="300"
          :align="allAlign"
          :data="tableDataAuditList">
              <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
              <vxe-table-column field="user_name" width="200" title="审核人"></vxe-table-column>
              <vxe-table-column field="audit_time"  width="200" title="审核日期"></vxe-table-column>
              <vxe-table-column field="audit_idear" title="意见"></vxe-table-column>
              <vxe-table-column field="status_name"  width="100" title="状态"></vxe-table-column>
          </vxe-table>
      </div>
    </div>
  </template>
  
  <script>
  import { findByIdDetails } from '@/api/activityCustomer'
  export default {
    data() {
      return {
        listLoading: false,
        form: {
          org_id_text: '',
          sq_name: '',
          sq_type_text: '',
          sh_address: '',
          sh_phone: '',
          sh_zip: '',
          cdate: '',
          usage: '',
          rel_inv_code: '',
          type_accord: '',
          amount_accord: '',
          signed_time: '',
          mt_signed: '',
        },
        // 表格数据
        tableData: [],
        tableDataAuditList:[],
        allAlign: 'center',
        org_ID:'',
        sqcostNum: 0,
        spcostNum: 0
      };
    },
    created() {
      // this.org_ID = '28749' 
      this.org_ID = this.$route.query.id
      if (this.$route.query.id) {
        this.queryByPage()
      }
    },
    methods: {
      // 搜索表格数据
      async queryByPage() {
        this.listLoading = true // 开启加载动画
        findByIdDetails(this.org_ID).then(res => {
          if (res.code === 1 && res.data) {
            let data = res.data
            this.form = data.materialApply || this.form
            this.tableData = data.materialList
            this.tableDataAuditList = data.auditList
            this.sqcostNum = data.materialList.reduce((sum, item) => sum + Number(item.sqcost), 0);
            this.spcostNum = data.materialList.reduce((sum, item) => sum + Number(item.spcost), 0);
            this.listLoading = false // 关闭加载动画
          }
        })
      },
      
      // 返回
      returnToLevel() {
        this.$router.push({ path: '/publicizeMaterialManagement/materialApplicationList'})
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  
  .top-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  /deep/ .ant-form {
    padding-right: 0 !important;
  }
   /deep/ .ant-form-item {
        display: flex;
   }
   /deep/ .ant-form-item-control-wrapper {
    width: 100%;
   }
   h5 {
    font-weight: bold;
   }
   .vxe-table--header th {
    background-color: #336699;
    color: #ffffff;
  }
  </style>